import React from 'react';
import { AspectRatioContainer } from '../layout/aspect-ratio-container';
import { Image } from './image';

export const AspectRatioImage = React.memo(({ aspectRatio, ...props }) => (
  <AspectRatioContainer aspectRatio={aspectRatio}>
    <Image fluid cover {...props} />
  </AspectRatioContainer>
));
